import React from "react";

const OrderOnlinePage = () => {
  return <div>OrderOnlinePage</div>;
};

export default OrderOnlinePage;
